exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".book-list[data-v-767394b1]{font-size:16px;color:var(--text)}", "", {"version":3,"sources":["F:/myugfront/src/components/presentations/chosen-topic.vue"],"names":[],"mappings":"AACA,4BACE,eAAgB,AAChB,iBAAmB,CACpB","file":"chosen-topic.vue","sourcesContent":["\n.book-list[data-v-767394b1] {\n  font-size: 16px;\n  color: var(--text);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-767394b1","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/presentations/chosen-topic.vue
// module id = 1141
// module chunks = 16